import ingredient from './modules/ingredient'

export default {
  ingredient
}
